import { render, staticRenderFns } from "./shop-item.vue?vue&type=template&id=47be087e&scoped=true&"
import script from "./shop-item.vue?vue&type=script&lang=js&"
export * from "./shop-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be087e",
  null
  
)

export default component.exports